class LookBookPin extends HTMLElement {
  constructor() {
    super()
    this.isActive = false
  }
  connectedCallback() {
    this.container = this.querySelector('.pin--container')
    this.pin = this.querySelector('.dot')
    this.pin_id = this.pin.dataset.pinId
    this.pin.addEventListener('click', this.handleClick.bind(this))
    document.addEventListener('pin-active', this.otherActiveListener.bind(this))
    document.body.addEventListener('click', this.closeOnBodyClick.bind(this))
  }
  handleClick() {
    this.container.classList.toggle('active')
    var event = new CustomEvent("pin-active", { "detail": { id: this.pin_id } });
    document.dispatchEvent(event)
  }
  otherActiveListener(e) {
    const id = e.detail.id
    const container = this.querySelector('.pin--container')
    if(this.pin_id != id) {
      if(container.classList.contains('active')) container.classList.remove('active')
    }
  }
  closeOnBodyClick(e) {
    const isChild = this.container.contains(e.target)
    if(!e.target.isSameNode(this.pin) && !isChild) {
      const container = this.querySelector('.pin--container')
      if(container.classList.contains('active')) container.classList.remove('active')
    }
    
  }
}
customElements.define('lookbook-pin', LookBookPin)